export default __webpack_public_path__ + "static/media/jetstream-boring.6433fb83.svg";